import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { CustomerOrdersListComponent } from './customer-orders-list/customer-orders-list.component';
import { CustomerOrdersFormComponent } from './customer-orders-form/customer-orders-form.component';
import { SharedModule } from '../../../shared/shared.module';
import { DxModule } from '../../../shared/dx.module';
import { MaterialModule } from '../../../shared/material.module';
import { PendingChangesGuard } from 'src/app/guards';
import { CustomerOrderProductsListComponent } from './customer-order-products-list/customer-order-products-list.component';
import { CustomerOrderCostsComponent } from './customer-order-costs/customer-order-costs.component';
import { CustomerOrderNotesComponent } from './customer-order-notes/customer-order-notes.component';
import { ReportsModule } from 'src/app/shared/reports/reports.module';

export const ordersRoutes: Route[] = [
  {
    path: '',
    component: CustomerOrdersListComponent
  },
  {
    path: 'new',
    component: CustomerOrdersFormComponent,
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: ':id',
    component: CustomerOrdersFormComponent,
    canDeactivate: [PendingChangesGuard]
  }
];

@NgModule({
  declarations: [CustomerOrdersListComponent, CustomerOrdersFormComponent, CustomerOrderProductsListComponent, CustomerOrderCostsComponent, CustomerOrderNotesComponent],
  imports: [
    SharedModule,
    MaterialModule,
    DxModule,
    ReportsModule,
    RouterModule.forChild(ordersRoutes)
  ]
})
export class CustomerOrdersModule { }
